import React, { useEffect, useState } from 'react';
import { mapHireStatusToText } from '../../../utils';
import { HireStatus } from '../../../enums';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { responsesActions } from '../../../redux/slices/responsesSlice';
import { Button } from '../../../../../../base/components/Button';

import './styles.scss';
import { __t } from '../../../../../../base/utils/t';

interface Props {
    className?: string;
}

export const StatusSelectMobile = ({ className = '' }: Props) => {
    const dispatch = useAppDispatch();
    const { hireStatus } = useAppSelector((state) => state.employerResponses.filters);
    const [showSelectPopup, setShowSelectPopup] = useState(false);
    const [inputValue, setInputValue] = useState<HireStatus>(hireStatus);

    useEffect(() => {
        if (showSelectPopup) {
            document.documentElement.setAttribute('DisableScroll', 'true');
            return;
        }
        document.documentElement.removeAttribute('DisableScroll');

        return () => {
            document.documentElement.removeAttribute('DisableScroll');
        };
    }, [showSelectPopup]);

    const clearFilter = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        dispatch(responsesActions.setFiltersHireStatus(HireStatus.All));
    };

    const submitFilterButton = () => {
        dispatch(responsesActions.setFiltersHireStatus(inputValue));
        togglePopupVisibility();
    };

    const togglePopupVisibility = () => {
        setShowSelectPopup(!showSelectPopup);
    };

    const closePopupHandler = () => {
        setInputValue(hireStatus);
        togglePopupVisibility();
    };

    return (
        <>
            <div className={`responses-filters-mobile-select ${className}`} onClick={togglePopupVisibility}>
                {hireStatus !== HireStatus.All && (
                    <div onClick={clearFilter} className='responses-filters-mobile-select__clear-filter-button'>
                        <Icon icon='xmark-regular' size='14px' className='responses-filters-mobile-select__icon' />
                    </div>
                )}
                <span className='responses-filters-mobile-select__display-value-text'>
                    {mapHireStatusToText(hireStatus)}
                </span>
                <Icon icon='chevron-down-regular' size='14px' className='responses-filters-mobile-select__icon' />
            </div>

            {showSelectPopup && (
                <>
                    <div
                        className='responses-filters-mobile-select-popup__background'
                        onClick={closePopupHandler}
                    ></div>

                    <div className='responses-filters-mobile-select-popup'>
                        <div
                            onClick={closePopupHandler}
                            className='responses-filters-mobile-select-popup__close-button'
                        >
                            <Icon icon='xmark-regular' size='24px' color='white' />
                        </div>
                        <div className='responses-filters-mobile-select-popup__content'>
                            <div
                                className='responses-filters-mobile-select-popup__item'
                                onClick={() => setInputValue(HireStatus.NotInvited)}
                            >
                                <div
                                    className={`responses-filters-mobile-select-popup__check-icon ${
                                        inputValue === HireStatus.NotInvited
                                            ? 'responses-filters-mobile-select-popup__check-icon--checked'
                                            : ''
                                    }`}
                                >
                                    {inputValue === HireStatus.NotInvited ? (
                                        <Icon icon='check' color='white' size='12px' />
                                    ) : null}
                                </div>
                                <span className='responses-filters-mobile-select-popup__item-text'>
                                    {mapHireStatusToText(HireStatus.NotInvited)}
                                </span>
                            </div>
                            <div
                                className='responses-filters-mobile-select-popup__item'
                                onClick={() => setInputValue(HireStatus.Invited)}
                            >
                                <div
                                    className={`responses-filters-mobile-select-popup__check-icon ${
                                        inputValue === HireStatus.Invited
                                            ? 'responses-filters-mobile-select-popup__check-icon--checked'
                                            : ''
                                    }`}
                                >
                                    {inputValue === HireStatus.Invited ? (
                                        <Icon icon='check' color='white' size='12px' />
                                    ) : null}
                                </div>
                                <span className='responses-filters-mobile-select-popup__item-text'>
                                    {mapHireStatusToText(HireStatus.Invited)}
                                </span>
                            </div>
                            <div
                                className='responses-filters-mobile-select-popup__item'
                                onClick={() => setInputValue(HireStatus.InProgress)}
                            >
                                <div
                                    className={`responses-filters-mobile-select-popup__check-icon ${
                                        inputValue === HireStatus.InProgress
                                            ? 'responses-filters-mobile-select-popup__check-icon--checked'
                                            : ''
                                    }`}
                                >
                                    {inputValue === HireStatus.InProgress ? (
                                        <Icon icon='check' color='white' size='12px' />
                                    ) : null}
                                </div>
                                <span className='responses-filters-mobile-select-popup__item-text'>
                                    {mapHireStatusToText(HireStatus.InProgress)}
                                </span>
                            </div>
                            <div
                                className='responses-filters-mobile-select-popup__item'
                                onClick={() => setInputValue(HireStatus.Hired)}
                            >
                                <div
                                    className={`responses-filters-mobile-select-popup__check-icon ${
                                        inputValue === HireStatus.Hired
                                            ? 'responses-filters-mobile-select-popup__check-icon--checked'
                                            : ''
                                    }`}
                                >
                                    {inputValue === HireStatus.Hired ? (
                                        <Icon icon='check' color='white' size='12px' />
                                    ) : null}
                                </div>
                                <span className='responses-filters-mobile-select-popup__item-text'>
                                    {mapHireStatusToText(HireStatus.Hired)}
                                </span>
                            </div>
                            <Button
                                onClick={submitFilterButton}
                                className='responses-filters-mobile-select-popup__submit-button'
                            >
                                {__t('Фільтрувати відгуки')}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
